var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view app-main-page-tab" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticClass: "cargo-advance-search bpm-approval-process",
            staticStyle: {
              width: "100%",
              "margin-top": "5px",
              "min-width": "1280px"
            }
          },
          [
            _c(
              "div",
              { staticClass: "section" },
              [
                _c(
                  "el-form",
                  {
                    attrs: { "label-position": "left", "label-width": "85px" }
                  },
                  [
                    _c(
                      "el-row",
                      {
                        staticStyle: { "margin-bottom": "5px" },
                        attrs: { gutter: 10 }
                      },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.toQuery }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Query")) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.toCreateProcess }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_CreateProcess")
                                    ) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.toEditProcess }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_EditProcess")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("Tool.platformId"),
                                  "label-width": "70px"
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "tenantId",
                                    "select-type": _vm.selectTypeNames.TENANT,
                                    url: _vm.URL.sys.tenant,
                                    cache: false,
                                    filterable: "",
                                    "show-custom-label-in-option": true,
                                    "custom-label": _vm.companyLabel,
                                    "callback-method-type": "value"
                                  },
                                  on: {
                                    parentCallBack:
                                      _vm.filterTenantIdChangeHandler
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "CargoMsg.Cargo_ApplicationBranch1"
                                  ),
                                  "label-width": "85px"
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    filterable: "",
                                    no: "officeIds",
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Office,
                                    cache: false,
                                    multiple: true,
                                    "default-multiple-value":
                                      _vm.filter.officeIds,
                                    "static-options": _vm.filterOffices,
                                    clearable: ""
                                  },
                                  on: {
                                    parentCallBack: function(item) {
                                      return (_vm.filter.officeIds = item.value)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_FormName"),
                                  "label-width": "70px"
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    "tag-value": "code",
                                    "static-options": _vm.workflowTypes
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.filter.documentConfigId = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                attrs: {
                                  label: _vm.$t(
                                    "CargoMsg.Cargo_WhetherItIsEnabled"
                                  ),
                                  prop: "initiateBranchCompany",
                                  "label-width": "70px"
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    "static-options": _vm.yesOrNotList,
                                    clearable: "",
                                    "tag-value": "code",
                                    "default-value": _vm.filter.enabled
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.filter.enabled = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "config-module": "260309",
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                },
                rowDataChanged: _vm.rowDataChanged
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.filter.total > 0,
                  expression: "filter.total>0"
                }
              ],
              attrs: {
                "config-module": "260309",
                total: _vm.filter.total,
                page: _vm.filter.pageNum,
                limit: _vm.filter.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.filter, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.filter, "pageSize", $event)
                },
                pagination: _vm.toQuery
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog",
          attrs: {
            slot: "reference",
            "close-on-click-modal": false,
            visible: _vm.showPlatformSettingDialog,
            title: _vm.platformSettingTitle,
            "inline-message": "",
            width: "390px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showPlatformSettingDialog = $event
            }
          },
          slot: "reference"
        },
        [
          _c(
            "el-form",
            {
              ref: "platformSetting",
              attrs: {
                model: _vm.documentPlatformConfigForm,
                "label-width": "110px",
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Tool.platformId"), required: "" } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "235px" },
                    attrs: {
                      no: "tenantId",
                      "select-type": _vm.selectTypeNames.TENANT,
                      url: _vm.URL.sys.tenant,
                      cache: false,
                      filterable: "",
                      "show-custom-label-in-option": true,
                      "custom-label": _vm.companyLabel,
                      "callback-method-type": "value",
                      "default-value": String(
                        _vm.documentPlatformConfigForm.tenantId || ""
                      )
                    },
                    on: { parentCallBack: _vm.tenantIdChangeHandler }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ApplicationBranch1"),
                    required: ""
                  }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "235px" },
                    attrs: {
                      no: "officeIds",
                      "select-type": _vm.selectTypeNames.basic_data_Office,
                      cache: false,
                      filterable: "",
                      multiple: true,
                      "default-multiple-value":
                        _vm.documentPlatformConfigForm.officeIds,
                      "static-options": _vm.offices,
                      placeholder: ""
                    },
                    on: { parentCallBack: _vm.officeIdChangeHandler }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_FormName"),
                    required: ""
                  }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "235px" },
                    attrs: {
                      no: "75",
                      "select-type":
                        _vm.selectTypeNames.basic_data_WorkflowTypes,
                      cache: false,
                      filterable: "",
                      "default-value":
                        _vm.documentPlatformConfigForm.documentConfigId,
                      "static-options": _vm.workflowTypes,
                      "tag-value": "code",
                      placeholder: ""
                    },
                    on: {
                      parentCallBack: function(item) {
                        return (_vm.documentPlatformConfigForm.documentConfigId =
                          item.value)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "CargoMsg.Cargo_NumberOfConfigurableBranches"
                    ),
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "235px" },
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.documentPlatformConfigForm.branchCount,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.documentPlatformConfigForm,
                            "branchCount",
                            $$v
                          )
                        },
                        expression: "documentPlatformConfigForm.branchCount"
                      }
                    },
                    _vm._l(_vm.branchCountDropList, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_AdministratorSettings"),
                    required: ""
                  }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "235px" },
                    attrs: {
                      no: "userIds",
                      "select-type": _vm.selectTypeNames.basic_data_User,
                      cache: false,
                      filterable: "",
                      multiple: true,
                      "default-multiple-value":
                        _vm.documentPlatformConfigForm.userIds,
                      "static-options": _vm.userList,
                      placeholder: _vm.$t("CargoMsg.Cargo_PleaseSelectUser")
                    },
                    on: {
                      parentCallBack: function(item) {
                        return (_vm.documentPlatformConfigForm.userIds =
                          item.value)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "label-none custom",
                  attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "235px" },
                    attrs: { type: "textarea", rows: 5 },
                    model: {
                      value: _vm.documentPlatformConfigForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.documentPlatformConfigForm, "remark", $$v)
                      },
                      expression: "documentPlatformConfigForm.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_DocumentPlatformConfigNote"))
                )
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c("el-button", { on: { click: _vm.cancel } }, [
                _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }